"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var qs_1 = require("qs");
var elog = require("../elog");
var core_link_1 = require("./core_link");
var url_helpers_1 = require("../url_helpers");
var COMPONENT_NAME = 'BrandCard';
var BrandCard = /** @class */ (function (_super) {
    tslib_1.__extends(BrandCard, _super);
    function BrandCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrandCard.prototype.getLink = function () {
        if (this.props.linkOverride && !this.props.linkOverrideAsQueryString) {
            return this.props.linkOverride;
        }
        // this is special behavior for the BrandCollection CMS component
        if (this.props.linkOverride) {
            var parts = this.props.linkOverride.split('?');
            var path = parts[0];
            var overrideQuery = qs_1.parse(parts[1]);
            var query = qs_1.stringify(tslib_1.__assign({ make: this.props.brand.slug }, overrideQuery));
            return path + "?" + query;
        }
        if (!this.props.linkOverride && this.props.rootCategorySlug) {
            var query = {
                product_type: this.props.rootCategorySlug,
            };
            if (this.props.leafCategorySlug) {
                query['category'] = this.props.leafCategorySlug;
            }
            var routeContext = tslib_1.__assign(tslib_1.__assign({}, query), { brand_slug: this.props.brand.slug });
            return url_helpers_1.BRAND_ROUTE.expand(routeContext);
        }
        return this.props.brand.webLink && this.props.brand.webLink.href;
    };
    BrandCard.prototype.render = function () {
        try {
            if (!this.props.brand) {
                return (React.createElement("div", { className: "brand-card brand-card--placeholder" },
                    React.createElement("div", { className: "brand-card__link" })));
            }
            return (React.createElement("div", { className: "brand-card" },
                React.createElement(core_link_1.default, { to: this.getLink(), position: this.props.position, entityId: this.props.brand.id, className: "brand-card__link" },
                    React.createElement("h4", { className: "brand-card__title" }, this.props.brand.name))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    return BrandCard;
}(React.Component));
exports.default = BrandCard;
//# sourceMappingURL=brand_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/brand_card.js
// module id = I1sB
// module chunks = 0 1 2 4 6 8 20